/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { noop } from 'lodash';
import { Modal } from '@blend/enterprise-components';

import { ModalContent } from 'blb-components/ModalContent';
import { DocumentWithTag } from 'blb-ui-types/BridgeTypes';
import { DisablednessContext } from 'blb-contexts/Disabledness';

import { DocsTable } from './DocsTable';
export namespace DownloadableDocsModal {
  export interface Props {
    collateFileName: string;
    docsWithTag: DocumentWithTag[];
    documentTypeLabel?: string;
    handleClose: () => void;
    isOpen: boolean;
    isUploaded: boolean;
    title: string;
  }
}

export const DownloadableDocsModal: React.FC<DownloadableDocsModal.Props> = ({
  collateFileName,
  docsWithTag,
  handleClose,
  isOpen,
  isUploaded,
  title,
  documentTypeLabel,
}) => {
  const { disabled } = useContext(DisablednessContext);
  const closeHandler = disabled ? noop : handleClose;
  const content = (
    <ModalContent handleClose={closeHandler} headerText={title}>
      <DocsTable
        collateFileName={collateFileName}
        documentTypeLabel={documentTypeLabel}
        documents={docsWithTag}
        handleClose={closeHandler}
        isUploaded={isUploaded}
      />
    </ModalContent>
  );
  return (
    <Modal contentLabel={title} handleClose={closeHandler} isOpen={isOpen}>
      {content}
    </Modal>
  );
};
